import EditNews from './EditNews';

export default EditNews;
